<template>
  <div
    class="pop-up-overlay-component-frame"
    :style="/*NOTE: if color-1 is listed in class, border color is not changeable*/`
      width: ${width || '90%'};
      z-index: ${z_index || 1};
      background-color: var(--v-color-1-base) !important;
      ${position_css
        ? position_css
        : 'top: 50vh; left: 50vw; transform: translate(-50%, -50%);'
      }
    `"
    v-click-outside="closeOverlay"
  >
    <div
      class="pop-up-overlay-component-container"
      :style="`margin: ${margin || 16}px`"
    >
      <div v-if="$slots.head" class="pop-up-overlay-component-head">
        <slot name="head"/>
        <div color="primary" class="pop-up-overlay-component-head-line"/>
      </div>
      <div class="pop-up-overlay-component-body">
        <slot name="body"/>
      </div>
      <div v-if="!is_no_cancel" class="pop-up-overlay-component-buttons">
        <slot name="additional_v-btn_left"/>
        <v-btn @click="closeOverlay">
          <TText value="Close" font_weight="400"/>
        </v-btn>
        <slot name="additional_v-btn_right"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: [
      'width', // is string, allows to put in custom unit for pop-up width
      'margin', // is number, controls inner margin
      'position_css', // is css string, should contains bot, top, left, right, transform: translate() etc
      'z_index', // is number, should be used to force higher z-index
      'is_no_cancel', // is boolean, disables pop-up-overlay-component-buttons
    ],

    data: () => ({

    }),

    methods: {
      closeOverlay() {
        this.$emit('closeOverlay');
      },
    },
  }
</script>

<style>
.pop-up-overlay-component-frame {
  position: absolute;
  /* width: 90%; */
  /* height: auto; */
  /* height: 100%; */
  /* top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
  /* z-index: 1; */
  border-radius: 8px;
}
.pop-up-overlay-component-container {
  /* margin: 16px; */
  width: auto;
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
}
.pop-up-overlay-component-body {
  /* min-height: 64px; */
}
.pop-up-overlay-component-buttons {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  grid-gap: 8px;
}
.pop-up-overlay-component-buttons > .v-btn,
.pop-up-overlay-component-v-btn {
  letter-spacing: normal !important;
  text-indent: 0 !important;
  text-transform: none !important;
  color: var(--v-primary-base);
  background-color: rgba(0, 0, 0, 0) !important;
  border: 1px solid;
  min-width: 80px;
}
.pop-up-overlay-component-head-line {
  padding-top: 8px;
  border-bottom: 1px solid;
  opacity: .25;
}
</style>
